export default __webpack_public_path__ + "static/media/pending.9fe5970d.svg";